import { __decorate } from "tslib";
import { provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import { PaymentReminderOverlayComponent } from './payment-reminder-overlay';
import * as i0 from "@angular/core";
let PaymentReminderFrontendFeature = /*#__PURE__*/(() => {
  let PaymentReminderFrontendFeature = class PaymentReminderFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/payment-reminder/frontend","featureId":"common-payment-reminder"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineRootComponents([{
        component: PaymentReminderOverlayComponent
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵPaymentReminderFrontendFeature_BaseFactory;
        return function PaymentReminderFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵPaymentReminderFrontendFeature_BaseFactory || (ɵPaymentReminderFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(PaymentReminderFrontendFeature)))(__ngFactoryType__ || PaymentReminderFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: PaymentReminderFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([
          // {path: 'payment-reminder', loadChildren: () => ... }
        ])
        // provideFeatureAddonRoutes([])
        ]
      });
    }
  };
  PaymentReminderFrontendFeature = __decorate([ClassName("PaymentReminderFrontendFeature")], PaymentReminderFrontendFeature);
  return PaymentReminderFrontendFeature;
})();
export { PaymentReminderFrontendFeature };